// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","fundProfileAdminsList":"UV9kk9nNzoldJw2PwsejP","fundProfileAdminsListItem":"_1EK41WpxDD8E79p_UKDN8Y"};